import Vue from 'vue';
import VueRouter from 'vue-router';


Vue.use(VueRouter);

import login from '@/pages/login';
import home from '@/pages/home';
import management from '@/pages/pop_ups/management';
import qulity from '@/pages/pop_ups/qulity';
import material from '@/pages/pop_ups/material';
import equipment from '@/pages/pop_ups/equipment';

import division from '@/pages/pop_ups/management/division';
import schedule from '@/pages/pop_ups/management/schedule';
import mission from '@/pages/pop_ups/management/mission';
import events from '@/pages/pop_ups/management/events';


import event_management from '@/pages/pop_ups/qulity/event_management';
import overview from '@/pages/pop_ups/qulity/overview';
import relaying from '@/pages/pop_ups/qulity/relaying';

import eq_event_management from '@/pages/pop_ups/equipment/event_management';
import eq_overview from '@/pages/pop_ups/equipment/overview';
import eq_management from '@/pages/pop_ups/equipment/eq_management';


import enter from '@/pages/pop_ups/material/enter';
import overviewQulity from '@/pages/pop_ups/material/overview';
import material_amount from '@/pages/pop_ups/material/material_amount';


const router = new VueRouter({
    routes:[
        {
            path:'/',
            redirect:"/login",
        },
        {
            name: 'login',
            path: '/login',
            component: login,
        },
        {
            name: 'home',
            path: '/home',
            component: home,
            children:[
                {
                    showName: '工程管理',
                    name: 'management',
                    path: '/home/management',
                    component: management,
                    children:[
                        {
                            showName: '工程划分',
                            name: 'division',
                            path: '/home/management/division',
                            component: division,
                        },
                        {
                            showName: '进度计划',
                            name: 'schedule',
                            path: '/home/management/schedule',
                            component: schedule,
                        },
                        {
                            showName: '任务发送',
                            name: 'mission',
                            path: '/home/management/mission',
                            component: mission,
                        },
                        {
                            showName: '事件管理',
                            name: 'events',
                            path: '/home/management/events',
                            component: events,
                        },
                    ]
                },
                {
                    showName: '质量管理',
                    name: 'qulity',
                    path: '/home/qulity',
                    component: qulity,
                    children:[
                        {
                            showName: '质量概览',
                            name: 'overview',
                            path: '/home/qulity/overview',
                            component: overview,
                        },
                        {
                            showName: '重铺计划',
                            name: 'relaying',
                            path: '/home/qulity/relaying',
                            component: relaying,
                        },
                        {
                            showName: '事件管理',
                            name: 'event_management',
                            path: '/home/qulity/event_management',
                            component: event_management,
                        },
                        
                    ]
                },
                {
                    showName: '材料管理',
                    name: 'material',
                    path: '/home/material',
                    component: material,
                    children:[
                        {
                            showName: '质量概览',
                            name: 'overviewQulity',
                            path: '/home/material/overview',
                            component: overviewQulity,
                        },
                        {
                            showName: '进场计划',
                            name: 'enter',
                            path: '/home/material/enter',
                            component: enter,
                        },
                        {
                            showName: '材料使用',
                            name: 'material_amount',
                            path: '/home/material/material_amount',
                            component: material_amount,
                        },
                        
                    ]
                    
                },
                {
                    showName: '设备管理',
                    name: 'equipment',
                    path: '/home/equipment',
                    component: equipment,
                    children:[
                        {
                            showName: '设备概览',
                            name: 'eq_overview',
                            path: '/home/equipment/eq_overview',
                            component: eq_overview,
                        },
                        {
                            showName: '事件管理',
                            name: 'eq_event_management',
                            path: '/home/equipment/eq_event_management',
                            component: eq_event_management,
                        },
                        {
                            showName: '设备管理',
                            name: 'eq_management',
                            path: '/home/equipment/eq_management',
                            component: eq_management,
                        },
                        
                    ]
                },
            ]
        },
       

    ],
});

// // 路由前置守卫
// router.beforeEach((to, from, next) => {
//     // 默认所有icon为false
//     for (let key in store.state.funcBarDevelop) {
//         store.state.funcBarDevelop[key] = false
//     }
//     const isLogine = localStorage.getItem("token");
//     if (to.name == 'login' || to.name == "demo" || to.name == "mobile_login" || to.name == "home") {
//         // 无需权限即可访问的路由
//         next();
//     }
//     else if (isLogine && to.name == "home") {
//         // 登录后就可以访问首页路由
//         next();
//     }
//     else if (isLogine) {
//         // 登录后且需要校验权限才可以访问的路由
//         if (router.checkPermission(to.name)) {
//             next();
//         } else {
//             Message({
//                 message: "您无权限访问此页面",
//                 type: 'warning'
//             })
//         }
//     }
//     else {
//         //否则清空本地存储,路由跳回为/的路由地址!
//         localStorage.clear();
//         router.push("/");
//     }
// });

            

export default router